import { render, staticRenderFns } from "./AccordionProductAvailability.vue?vue&type=template&id=89c54cc6&"
import script from "./AccordionProductAvailability.vue?vue&type=script&lang=js&"
export * from "./AccordionProductAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports